

import moment from 'moment-timezone';

export const calculateTimeLeft = (endDateString) => {
  if (!endDateString) {
    return null; // No date provided
  }

  
  const endDateUtc = moment.utc(endDateString);

  const now = moment();

  if (endDateUtc.isBefore(now)) {
    return 'Plan Expired';
  }

  const duration = moment.duration(endDateUtc.diff(now));

  const totalDays = Math.floor(duration.asDays());

  if (totalDays >= 1) {
    const dayText = totalDays === 1 ? 'day' : 'days';
    return `${totalDays} ${dayText} left`;
  }

  // Use total number of hours for the second check
  const totalHours = Math.floor(duration.asHours());
  
  if (totalHours >= 1) {
    // --- Case 2: Less than a day, but at least 1 hour ---
    // Get the components for this display
    const hours = duration.hours();
    const minutes = duration.minutes();
    return `${hours}h ${minutes}m left`;
  } else {
    // --- Case 3: Less than 1 hour ---
    // Get the components for this display
    const minutes = duration.minutes();
    const seconds = duration.seconds();
    return `${minutes}m ${seconds}s left`;
  }
};
export const isPlanExpired = (endDateString) => {
  if (!endDateString) {
    // If there is no end date, we'll consider the plan not expired.
    return false;
  }
  
  // Create a moment object from the UTC date string
  const endDateUtc = moment.utc(endDateString);
  
  // Check if the end date is before the current time
  return endDateUtc.isBefore(moment());
};